module.exports = __webpack_public_path__ + "static/media/presentation.41e8f510.svg";